module.exports = __webpack_public_path__ + "img/single-choice.eb317ec9.svg";